import styled from 'styled-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeroH1, HeroH2, ButtonSpan } from '../components/Typography';
import { Link } from 'react-router-dom';

const langUrl = (url) => {
  const isZh = window.location.pathname.includes("/zh");
  return `${isZh ? "/zh" : ""}${url}`;
}

const CTA = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #C5B9AC;
  height: 394px;
  text-align: center;

  h2 {
    margin-bottom: 60px;
  }

  // a {
  //   background-color: white;
  //   color: #C4B8AC;
  //   display: inline-block;
  //   font-size: 11px;
  //   font-weight: 500;
  //   letter-spacing: 3.3px;
  //   line-height: 27px;
  //   text-align: center;
  //   text-decoration: none;
  //   text-transform: uppercase;
  //   width: 144px;
  // }
`

export default ({ className }) => {
  const { t } = useTranslation();

  return <CTA className={className}>
    <div>
      <HeroH1>{ t('Exclusive Waterfront Homes') }</HeroH1>
      <HeroH2>{ t('Enquire today for further information about TESORO.') }</HeroH2>
      <Link to={langUrl("/enquire")}><ButtonSpan className="inverted" width={144}>{ t('Enquire') }</ButtonSpan></Link>
    </div>
  </CTA>
} 